import axios from "axios";
import type { AxiosInstance } from 'axios'
const service: AxiosInstance = axios.create({
    // withCredentials: true,
    // baseURL: 'https://yiqixueapitest.fooktech.cn/',
    baseURL:'https://elyqxapi.eelian.com.cn/', 
    timeout: 10000,
})
export default service